<template>
  <!-- Detalle de un suministro de inmueble (referencia visual del cliente,
       16/09/2026): una tarjeta con CUPS, dirección, CP, municipio y provincia,
       y debajo la tarifa con el cuadro de potencias P1-P6 (solo luz). Un
       inmueble no tiene compañía, CIF, IBAN ni fin de contrato: esos son datos
       del contrato de una comunidad y no se muestran aquí. -->
  <div class="p-8 rounded-xl border shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] flex flex-col gap-2" data-testid="estate-supply-detail">
    <div class="grid lg:grid-cols-5 md:grid-cols-2 grid-cols-1 gap-6">
      <inputPrimary :modelValue="row.cups" :label="$t('property.estateSupplies.columns.cups')" class="p-4" readonly />
      <inputPrimary :modelValue="row.address" :label="$t('property.estateSupplies.columns.address') + ':'" class="p-4" readonly />
      <inputPrimary :modelValue="row.postal_code" :label="$t('property.estateSupplies.columns.postalCode') + ':'" class="p-4" readonly />
      <inputPrimary :modelValue="row.municipality" :label="$t('property.estateSupplies.columns.municipality') + ':'" class="p-4" readonly />
      <inputPrimary :modelValue="row.province" :label="$t('property.estateSupplies.columns.province') + ':'" class="p-4" readonly />
    </div>
    <div class="grid lg:grid-cols-5 md:grid-cols-2 grid-cols-1 gap-6">
      <inputPrimary :modelValue="row.rate" :label="$t('property.estateSupplies.columns.rate') + ':'" class="p-4" readonly />
      <div v-if="type === 'light'" class="p-4 lg:col-span-2" data-testid="estate-supply-powers">
        <p class="text-[#385660] mb-2">{{ $t('property.estateSupplies.columns.powers') }}:</p>
        <ul class="grid grid-cols-2 md:grid-cols-3 gap-2 rounded-md p-3 text-sm border shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">
          <li v-for="period in POWER_PERIODS" :key="period">
            <span class="font-semibold">{{ period.toUpperCase() }}:</span>
            <span class="text-[#7CADB9]"> {{ powerValue(period) }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import inputPrimary from '@/components/inputs/input-primary.vue';
import { estateSupplyRow } from '@/services/estateSupplies';
import { POWER_PERIODS } from '@/constants/supplyRates';

const props = defineProps({
  supply: { type: Object, required: true },
  type: { type: String, required: true, validator: (value) => ['light', 'gas'].includes(value) },
});

const row = computed(() => estateSupplyRow(props.supply, props.supply.property || {}));
const powerValue = (period) => {
  const value = props.supply?.[period];
  return value === null || value === undefined || String(value).trim() === '' ? '-' : String(value);
};
</script>
